<template>
    <v-container>
      <div class="esign-backbar">
        <v-btn text class="esign-back-btn" @click="back()">
          <v-icon left>mdi-arrow-left</v-icon> Kembali
        </v-btn>
      </div>
      <div class="mb-5">
        <material-card color="primary" title="Detail Pengaturan Eksternal" class="card-wrapper">
          <v-form>
            <v-row> 
              <v-col cols="12" md="12">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Nama</p>
                  <v-text-field 
                    dense
                    placeholder="Nama" 
                    readonly
                    outlined
                    v-model="formData.nama_app"
                    @input="$v.formData.nama_app.$touch()"
                    @blur="$v.formData.nama_app.$touch()"
                    :error-messages="namaErrors"
                  />
                </div>
                <p v-if="errorMessageNama" style="color:red;">{{errorMessage}}</p>
              </v-col>
              <v-col cols="12" md="12">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Secret Key</p>
                  <v-text-field 
                    dense
                    placeholder="Secret Key"
                    readonly
                    outlined
                    v-model="formData.secret_key"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">CallBack</p>
                  <v-text-field 
                    dense
                    placeholder="CallBack" 
                    readonly
                    outlined
                    v-model="formData.call_back"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Daftar Whitelist IP</p>
                  <v-textarea 
                    dense
                    placeholder="Whitelist IP"
                    readonly
                    outlined
                    v-model="formData.whitelist_ip"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Daftar Auth Config</p>
                  <v-textarea 
                    dense
                    placeholder="Auth Config"
                    readonly
                    outlined
                    v-model="formData.auth_config"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Daftar Header Config</p>
                  <v-textarea 
                    dense
                    placeholder="Header Config"
                    readonly
                    outlined
                    v-model="formData.header_config"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Daftar Body Config</p>
                  <v-textarea 
                    dense
                    placeholder="Body Config"
                    readonly
                    outlined
                    v-model="formData.body_config"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Keterangan</p>
                  <v-textarea 
                    dense
                    placeholder="Keterangan"
                    readonly
                    outlined
                    v-model="formData.keterangan"
                  />
                </div>
              </v-col>
              <v-col cols="12" class="text-right">
              </v-col>
            </v-row>
          </v-form>
        </material-card>
      </div>

    </v-container>
  </template>
  
<script>
  import { apiServer } from "../../setup-axios";
  export default {
    data: () => ({
      organisasis: [],
      allperans: [],
      successCreate: null,
      formData: {
        app_id: "",
        nama_app:"",
        secret_key:"",
        call_back:"",
        whitelist_ip:"",
        auth_config:"",
        header_config:"",
        body_config:"",
        keterangan:"",
      },
    }),
    mounted() {
      console.log("loading")
      this.getData();
    },
    methods: {
      getData() {
        console.log("get data " + this.$route.params.app_id)
        apiServer
          .get("/pengaturan-eksternal/detail/" + this.$route.params.app_id)
          .then(response => {
            console.log(response.data.data)
            this.formData = response.data.data;
            console.log(this.formData)
            this.formData.whitelist_ip = this.formData.whitelist_ip.replace(/,/g, "\n");
          })
          .catch(error => {
            console.log("There was an error:", error.response); // Logs out the error
          });
      },
     
      back() {
        this.$router.push('/pengaturan-eksternal')
      },
      close() {
        this.dialog = false;
      },
    }
  }
</script>
  